import {GetItemAsMsg, PromiseCallback} from "../types";

export class GetItemAsMsgDictionary implements GetItemAsMsg {
    private items: { [key: string]: PromiseCallback } = {};

    public containsKey(key: string): boolean {
        return this.items.hasOwnProperty(key);
    }

    public add(key: string, value: PromiseCallback): void {
        this.items[key] = value;
    }

    public remove(key: string): void {
        delete this.items[key];
    }

    public get(key: string): PromiseCallback {
        return this.items[key];
    }
}

export default new GetItemAsMsgDictionary();
